import type { SwiperContainer } from 'swiper/element';
import { ref, onMounted, onUnmounted } from 'vue';

export const useJourney = () => {
  const swiperRef = ref<SwiperContainer | null>(null);

  const currentIndex = ref(0);
  const paused = ref(false);
  const backDirection = ref(false);
  const isInitialized = ref(false);

  const autoplayObserver = ref<IntersectionObserver | null>(null);

  const slideChange = (el: any) => {
    const activeIndex = el.detail[0].activeIndex;
    backDirection.value = activeIndex < currentIndex.value;

    currentIndex.value = el.detail[0].activeIndex;
  };

  const click = (index: number) => {
    swiperRef.value?.swiper.slideTo(index);
  };

  const initAutoplay = () => {
    const section = document.querySelector('.journey-section');
    if (!section) return;

    autoplayObserver.value = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          swiperRef.value?.swiper.autoplay.start();
          paused.value = false;
        } else {
          paused.value = true;
          swiperRef.value?.swiper.autoplay.stop();
        }
      },
      {
        threshold: 0.5
      }
    );

    autoplayObserver.value.observe(section);
  };

  onMounted(async () => {
    swiperRef.value?.initialize();
    isInitialized.value = true;
    initAutoplay();
  });

  onUnmounted(() => {
    autoplayObserver.value?.disconnect();
    autoplayObserver.value = null;
  });

  return {
    swiperRef,
    currentIndex,
    paused,
    backDirection,
    isInitialized,
    slideChange,
    click
  };
};
